<script>
import Repositories from '@/repositories/shared';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import Item from './item.vue';

import textMixin from '@/mixins/textMixin';

export default {
  page: {
    title: 'Item',
  },
  components: {
    Loading,
    Item,
  },
  mixins: [textMixin],
  data() {
    return {
      repository: null,
      isLoading: false,
      itemId: 0,
      items: [],
      searchText: '',
      type: '',
    };
  },
  created() {
    this.repository = Repositories.get(
      'consumption',
      this.$route.params.orgcode,
      this.$route.params.id,
      this.$route.query.key,
      this.$route.params.type
    );

    this.type = this.$route.params.type;
    window.onpopstate = () => {
      this.itemId = 0;
    };

    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        this.isLoading = true;

        if (this.$route.params.type == 'items') {
          this.itemId = this.$route.params.id;
        } else if (this.$route.params.type == 'categories') {
          let resp = await this.repository.customREST.getItemsByCategory(
            this.$route.params.id
          );
          this.items = resp.data;
        } else if (this.$route.params.type == 'categorytypes') {
          let resp = await this.repository.customREST.getItemsByCategoryType(
            this.$route.params.id
          );
          this.items = resp.data;
        }
      } catch {
        this.$toast.errorToast(this.$t('errors.errorLoading'));
      } finally {
        this.isLoading = false;
      }
    },
    itemClicked(itemId) {
      window.history.pushState({ itemId }, null);
      this.itemId = itemId;
    },
  },
  computed: {
    filteredList() {
      if (this.items == null || this.items.length == 0) return [];

      if (this.searchText == null) return this.items;

      let textSearches = this.searchText.split(' ');
      return this.items.filter((x) => {
        for (let text of textSearches) {
          if (!x.name.includes(text)) {
            return false;
          }

          return true;
        }
      });
    },
  },
};
</script>

<template>
  <div class="page">
    <loading
      :active="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="true"
    >
    </loading>

    <Item
      v-if="itemId != null && itemId > 0"
      :itemId="itemId"
      :repository="repository"
    />

    <div v-else-if="type != 'items'">
      <b-input
        v-model="searchText"
        :placeholder="$t('general.search')"
      ></b-input>

      <div class="items-list">
        <div
          class="item-row"
          v-for="item in filteredList"
          :key="item.id"
          @click="itemClicked(item.id)"
        >
          <span v-html="highlightMatches(item.name, searchText)"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
html {
  background-color: white;
}

.page {
  padding: 10px;
  width: 100%;
  background-color: white;
}

.item-row {
  padding: 10px;
  height: 50px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgb(226, 226, 226);
  cursor: pointer;
}
</style>